module.exports = __webpack_public_path__ + "static/img/ziranzhibao.94ef4d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/logo/ziranzhibao.jpg
// module id = GNVm
// module chunks = 0